module.exports = __webpack_public_path__ + "img/earth-badge.37cfc69e.png";